import apiClient from "@/services/apiClient";

export const adminDatabaseBackupService = {
  download: () => apiClient.get("/AdminDatabaseBackup/download", { responseType: "blob" }),
};
